import { Format } from './Format';

export function renderBars(
    container: d3.Selection<any>,
    series: Format[]
): void {
    const dataBound = container
        .selectAll('.bars')
        .data(series.filter(r => r.series.isBarsVisible()));
    dataBound
        .exit()
        .remove();
    dataBound
        .enter()
        .append('g')
        .classed('bars', true)
        .classed('series-container', true);
    dataBound
        .attr('data-identifier', s => 'id' + s.series.identifier())
        .classed('hidden', d => !d.series.isVisible());

    const seriesBound = dataBound
        .selectAll('rect')
        .data(d => d.data);
    seriesBound
        .exit()
        .remove();
    seriesBound
        .enter()
        .append('rect');
    seriesBound
        .attr('x', d => d.x - d.width / 2)
        .attr('y', d => d.y)
        .attr('width', d => d.width)
        .attr('height', d => d.height)
        .style('fill', d => d.color)
        .style('stroke', d => d.color);
}